import { Button, Collapse, Form, Input } from "antd";
import styled from "styled-components";
import { ImageUpload } from "../../../ui/formItemComponents/ImageUpload";
import { FormInstance } from "antd/es/form/Form";
import { mimeTypes } from "../../story/components/form/InitialStoryForm";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Wysiwyg } from "../../../ui/wysiwyg/Wysiwig";
import { addContentImage } from "../../../api/requests/content";

const uploadImage = `${process.env.REACT_APP_CONTENT}/Content/AddImage`;

interface IProps {
  form: FormInstance<any>;
  lang: string;
}

export const FormPlayerOfMonthAndSeason = ({ form, lang }: IProps) => {
  return (
    <Container>
      {/**Баннер */}
      {/* <Collapse>
        <Collapse.Panel header="Баннер на главной странице" key={"banner"}>
          <Form.Item>
            <ImageUpload
              updateImage={form.getFieldValue("banner")}
              name={"banner"}
              label="Баннер"
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 375,
                height: 80,
                size: 10
              }}
              form={form}
            />
          </Form.Item>
        </Collapse.Panel>
      </Collapse> */}
      {/**Превью */}
      <Collapse>
        <Collapse.Panel header="Превью на странице “Акции”" key={"preview"}>
          <Form.Item>
            <ImageUpload
              updateImage={form.getFieldValue("preview")}
              name={"preview"}
              label="Превью"
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 343,
                height: 154,
                size: 10
              }}
              form={form}
            />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>

      {/**Награды */}
      <Collapse>
        <Collapse.Panel header="Награды" key={"awards"}>
          <Form.Item label={"Заголовок"} name={["awards", "title", lang]}>
            <Input />
          </Form.Item>

          <ListWrapper>
            <Form.List name={["awards", "list"]}>
              {(fields, { add, remove }) => (
                <>
                  <Collapse>
                    {fields.map(({ name, key }) => {
                      return (
                        <Collapse.Panel header="Награда" key={key + 1}>
                          <Form.Item name={[name, "award", lang]}>
                            <Input />
                          </Form.Item>
                          <MinusContainer>
                            <DeleteOutlined onClick={() => remove(name)} />
                          </MinusContainer>
                        </Collapse.Panel>
                      );
                    })}
                  </Collapse>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    {"Добавить награду"}
                  </Button>
                </>
              )}
            </Form.List>
          </ListWrapper>

          <Form.Item>
            <ImageUpload
              name={["awards", "icon"]}
              label="Иконка"
              updateImage={form.getFieldValue(["awards", "icon"])}
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 343,
                height: 218,
                size: 10
              }}
              form={form}
              deepFields={["awards", "icon"]}
            />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>

      {/**Условия */}
      <Collapse>
        <Collapse.Panel header="Условия" key={"conditions"}>
          <ListWrapper>
            <Form.List name={["conditions", "links"]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ name }) => {
                    return (
                      <>
                        <Form.Item>
                          <ImageUpload
                            updateImage={form.getFieldValue(["conditions", "links", name, "image"])}
                            name={[name, "image"]}
                            label="Иконка"
                            action={uploadImage}
                            deepFields={["conditions", "links", name, "image"]}
                            mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
                            entity={{
                              width: 112,
                              height: 76,
                              size: 10
                            }}
                            form={form}
                          />
                        </Form.Item>
                        <Form.Item label="Текст" name={[name, "text", lang]}>
                          <Wysiwyg uploadRequest={addContentImage} />
                        </Form.Item>
                        <Form.Item label="Ссылка" name={[name, "link", lang]}>
                          <Input />
                        </Form.Item>
                        <MinusContainer>
                          <DeleteOutlined onClick={() => remove(name)} />
                        </MinusContainer>
                      </>
                    );
                  })}

                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    {"Добавить условие"}
                  </Button>
                </>
              )}
            </Form.List>
          </ListWrapper>
        </Collapse.Panel>
      </Collapse>

      {/**Модалка */}
      <Collapse>
        <Collapse.Panel header="Модальное окно" key={"modal"}>
          <Form.Item label={"Заголовок"} name={["modal", "title", lang]}>
            <Input />
          </Form.Item>

          <ListWrapper>
            <Form.List name={["modal", "textList"]}>
              {(fields, { add, remove }) => (
                <>
                  <Collapse>
                    {fields.map(({ name, key }) => {
                      return (
                        <Collapse.Panel header="Текст" key={key + 1}>
                          <Form.Item name={[name, "text", lang]}>
                            <Input />
                          </Form.Item>
                          <MinusContainer>
                            <DeleteOutlined onClick={() => remove(name)} />
                          </MinusContainer>
                        </Collapse.Panel>
                      );
                    })}
                  </Collapse>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    {"Добавить текст"}
                  </Button>
                </>
              )}
            </Form.List>
          </ListWrapper>

          <Form.Item label={"Текст кнопки"} name={["modal", "buttonText", lang]}>
            <Input />
          </Form.Item>

          <Form.Item>
            <ImageUpload
              name={["modal", "buttonLogo"]}
              label="Логотип в кнопке"
              updateImage={form.getFieldValue(["modal", "buttonLogo"])}
              action={uploadImage}
              mimeTypes={[mimeTypes.image.jpg, mimeTypes.image.png]}
              entity={{
                width: 84,
                height: 20,
                size: 10
              }}
              form={form}
              deepFields={["modal", "buttonLogo"]}
            />
          </Form.Item>

          <Form.Item label={"Ссылка кнопки"} name={["modal", "buttonLink", lang]}>
            <Input />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>

      {/**Об акции */}
      <Collapse>
        <Collapse.Panel header="Об акции" key={"about"}>
          <Form.Item label={"Заголовок"} name={["about", "title", lang]}>
            <Input />
          </Form.Item>
          <br />
          <Form.Item label='Текст на странице "Aкции"' name={["about", "text", lang]}>
            <Wysiwyg uploadRequest={addContentImage} />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>

      {/**Правила акции */}
      <Collapse>
        <Collapse.Panel header="Правила акции" key={"rules"}>
          <Form.Item label={"Дата редакции"} name={["rules", "date", lang]}>
            <Input />
          </Form.Item>
          <br />
          <Form.Item name={["rules", "text", lang]}>
            <Wysiwyg uploadRequest={addContentImage} />
          </Form.Item>
        </Collapse.Panel>
      </Collapse>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .ant-form-item {
    margin: 0;
  }

  .ant-row {
    display: flex;
    flex-direction: column;

    .ant-col {
      text-align: left;
    }
  }

  .ant-form-item-control-input-content {
    & > div {
    }
  }
`;

const ListWrapper = styled.div`
  margin-top: 24px;
`;

const MinusContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 8px 0;
`;
